import React from 'react';

import { Helmet } from 'react-helmet';
import Paper from '@mui/material/Paper';

import NotesList  from 'src/component/UI/NotesList';
import { fetchNotes } from 'src/module/note/action';
import FilterBar from 'src/component/UI/FilterBar';

import { getNuisanceNotes, getLoadingNuisanceNotes, getNumNotesNuisancePages, getTotalNuisanceNotes } from 'src/module/note/selector';
import { isWhitelabel } from 'src/utils/utils';

export default function NuisanceScreen () {
  const selectors = {
    getNotes: getNuisanceNotes,
    getLoadingNotes: getLoadingNuisanceNotes,
    getNumNotesPages: getNumNotesNuisancePages,
    getTotalNotes: getTotalNuisanceNotes
  };

  const title = isWhitelabel() ? 'ATCOM' : 'SmartTrace';

  return (
    <div className='page' id='nuisance-screen'>
      <Helmet>
        <title>{title} - Nuisance</title>
      </Helmet>
      <FilterBar includeGrid />
      <br />
      <Paper>
        <NotesList
          noteType={'nuisance'}
          selectors={selectors}
          showSubject
          showExpiry
          showAddNoteButton
          showSearchBar
          showArchivedOption
          showDeleteIcon
          fetch={fetchNotes}
        />
      </Paper>
    </div>
  );
}
